<template>
<BaseModal
    :id="'discharge-beds-modal'"
    :title="title"
    :size="'lg'"
    :message="message"
    >
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb_modal"/>
    </template>

    <template v-slot:content >
        <div class="discharges-header mt-3">
            <div  class="d-flex form-discharges shadow p-3 mt-3 mb-3 bg-body rounded" style="gap: 0px;">
                <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options"/>
                <div class="modal__buttons text-center text-md-left text-lg-center" style="margin-top: 0px;">
                    <button
                        @click="addDischarge()"
                        class="modal__buttons__item"
                        v-html="`Add`"
                        style="width:5rem;"
                        type="button"
                        :disabled="loading_creation"
                        :class="{'disabled button__disabled' : loading_creation}"
                    />
                </div>
            </div>
        </div>
        <div class="tab-content mt-5" v-if="discharge_beds.length && hasPermissions(['Census-Vacant-Bed Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <div class="w-100 table-responsive defaultproject__table overflow-y--2 table-fix-head">
                            <table class="table">
                                <thead style="background-color: #ffff">
                                    <tr>
                                    <th
                                        style="font-weight: normal !important;"
                                        class="header-item-manual"
                                        v-for="(item, i) in discharge_beds_table_headers"
                                        :key="i"
                                        scope="col"
                                        v-html="item.text"
                                    />
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in discharge_beds" :key="i">
                                        <td v-html="`${i + 1}`" />
                                        <td style="width: 25%;">
                                            <div id="description" class="formdynamic__item__field mt-2">
                                                <select placeholder="Enter the description" required="required" class="custom-select" style="max-width: 100%;" :disabled="!item.editing" v-model="item.bed_id">
                                                    <option :value="bed.bed_id" v-for="(bed, i) in beds" :key="i" v-html="bed.bed_code" />
                                                </select>
                                            </div>
                                        </td>
                                        <td style="width: 15%;">
                                            <div class="p-0 form-discharges__minutes">
                                                <div class="formdynamic__item__field">
                                                    <input placeholder="minutes" type="number" v-model="item.minutes" :disabled="!item.editing">
                                                </div>
                                            </div>
                                        </td>
                                        <!-- <td style="width: 20%;">
                                            <div id="description" class="formdynamic__item__field mt-2">
                                                <select placeholder="Enter the description" required="required" class="custom-select" style="max-width: 100%;" :disabled="!item.editing" v-model="item.associate_id">
                                                    <option :value="associate.id" v-for="(associate, i) in associates" :key="i" v-html="associate.associate_name" />
                                                </select>
                                            </div>
                                        </td> -->
                                        <td>
                                            {{item.created_at ? moment(item.created_at).format("MM/D/YYYY hh:mm:ss A") : item.created_at}}
                                        </td>
                                        <td>
                                            <div class="modal__buttons" style="margin-top: 0.4rem;" v-if="is_loading !== i">
                                                <button type="button" class="modal__buttons__item" style="width: 3rem;" @click="item.editing ? update(item, i) : item.editing = true">{{item.editing ? 'Save' : 'Edit'}}</button>
                                                <button type="button" class="modal__buttons__item cancel" style="width: 4rem;" @click="remove(item, i)">Remove</button>
                                            </div>
                                            <div v-else>
                                                <div class="spinner-border" role="status">
                                                    <span class="sr-only">Loading...</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <form @submit.prevent="closeModal()">
            <CentralLiteButtons save_text="Done" style="margin-top: -.2rem;"/>
        </form>
        </template>
    </BaseModal>
</template>

<script>

import Resources          from    './resources'
import Breadcrumb         from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal          from    '@/components/BaseModal'
import CentralLiteButtons from    '@/components/CentralLiteButtons'
import FormDynamic      from    '@/components/FormDynamic.vue'
import moment from 'moment';
import FormResources from './form_resources'
import { emitDischargesForDashboard } from '../../../plugins/socket'

export default {
name: "FormModalDischargeBeds",
props: [
    "title",
    "parent_id",
    "daily_assignment",
    "breadcrumb_modal",
],

    components:{
        Breadcrumb,
        BaseModal,
        CentralLiteButtons,
        FormDynamic
    },

    data(){
        return {
            message: "You can edit the discharges entered for the assignment here. If you want to add discharges to beds, simply enter the required number of minutes. If you do not specify a number of minutes, the system will automatically save the discharge using the default minutes set for the linked assignment.",
            discharge_beds_table_headers: Resources.discharge_beds_table_headers,
            rest_api: 'log_productivity/discharge_beds',
            is_loading: -1, 
            loading_creation: false,
            form_format: FormResources.form_format_discharges,
            form_data: FormResources.form_data_discharges,
            discharge_beds: [],
            beds: [],
            associates: [],
            array_options: {
                bed_id: []
            },
            moment
        }
    },
    methods: 
    {
        async update(item, index)
        {
            const obj = {
                minutes: item.minutes,
                bed_id: item.bed_id,
                associate_id: item.associate_id
            }

            this.is_loading = index
            const res = await this.put(`${this.rest_api}/${item.id}`, obj)
            this.is_loading = -1

            if(res.status)
            {
                this.notyfMesg('Changes were saved')
                emitDischargesForDashboard(this.get_user().facility_id)
                item.editing = false
            }
            else
            {
                this.error_handling(res)
            }
        },

        async remove(item, index)
        {
            this.is_loading = index
            const res = await this.delete(`${this.rest_api}/${item.id}`,)
            this.is_loading = -1

            if(res.status)
            {
                this.notyfMesg('Item was removed')
                emitDischargesForDashboard(this.get_user().facility_id)
                this.discharge_beds.splice(index, 1)
            }
            else
            {
                this.error_handling(res)
            }
        },

        async getData() 
        {
            this.loader(true)

            const res = await this.get(`${this.rest_api}/${this.parent_id}`)

            this.loader()

            if(res.status)
            {
                const data = res.data
                this.discharge_beds = data.discharged_beds
                this.beds = data.beds
                this.array_options = {
                    bed_id: this.beds
                }
                this.associates = data.associates
                console.log(res.data);
            }
            else
            {
                this.error_handling(res)
            }

        },

        closeModal()
        {
            window.$(`#discharge-beds-modal`).modal('hide');
            this.$emit('refreshData', {})
        },

        async addDischarge()
        {
            if(!this.form_data.bed_id.length)
            {
                this.notyfMesg('Select a bed', 'error')
                return;
            }
            this.loading_creation = true

            const http_obj = {
                log_productivity_id: this.parent_id,
                ...this.form_data
            }

            const res = await this.post(`${this.rest_api}`, http_obj)

            this.loading_creation = false

            if(res.status)
            {
                emitDischargesForDashboard(this.get_user().facility_id)
                res.data.forEach(item => {
                    this.discharge_beds.push(item)
                })

                this.notyfMesg('Success')
                this.form_data.bed_id = []
                this.form_data.minutes = ''
            }
            else
            {
                this.error_handling(res)
            }
        }

    },

    computed: {
        array_options_table()
        {
            const sum = this.unassigned_work_items.reduce((acc, item) => {
                return acc + this.stringToNumber(item.minutes)
            }, 0)

            return [{text: 'Total minutes', value: sum, type: 'number'}]
        }
      },
};
</script>